export { ArrowDown } from './ArrowDown';
export { ArrowLeft } from './ArrowLeft';
export { ArrowRight } from './ArrowRight';
export { Banknote } from './Banknote';
export { Briefcase } from './Briefcase';
export { Building } from './Building';
export { Calendar } from './Calendar';
export { CheckCircle } from './CheckCircle';
export { ChevronDown } from './ChevronDown';
export { ChevronRight } from './ChevronRight';
export { CloudUpload } from './CloudUpload';
export { Edit } from './Edit';
export { Facebook } from './Facebook';
export { LifeBuoy } from './LifeBuoy';
export { Linkedin } from './Linkedin';
export { LogIn } from './LogIn';
export { LogOut } from './LogOut';
export { Mail } from './Mail';
export { MapPin } from './MapPin';
export { Menu } from './Menu';
export { MoreHorizontal } from './MoreHorizontal';
export { Phone } from './Phone';
export { PlusCircle } from './PlusCircle';
export { Search } from './Search';
export { Trash2 } from './Trash2';
export { X } from './X';
export { Youtube } from './Youtube';

import * as H from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { cn } from '../lib/cn';
/**
 * Prop types for all icon components
 */
export interface IconProps {
  className?: string;
  size?: number | string;
  strokeWidth?: number;
  color?: string;
}

/**
 * A factory function to create wrapped HugeIcons with default styling
 */
const createIcon = (IconData: any) => {
  const Component = ({
    className,
    size = 20,
    strokeWidth = 2,
    color,
  }: IconProps) => (
    <HugeiconsIcon
      icon={IconData}
      size={size}
      strokeWidth={strokeWidth}
      className={cn(className)}
      color={color}
    />
  );
  Component.displayName = IconData?.displayName || 'HugeIcon';
  return Component;
};

/**
 * Standardized icon components
 * To add a new icon, simply import it from @hugeicons/core-free-icons
 * and export it here using createIcon()
 */
export const AnalyticsUpIcon = createIcon(H.AnalyticsUpIcon);
export const ArchiveRestoreIcon = createIcon(H.ArchiveArrowUpIcon);
export const ArrowLeftIcon = createIcon(H.ArrowLeft01Icon);
export const BellIcon = createIcon(H.Notification01Icon);
export const BriefcaseIcon = createIcon(H.Briefcase01Icon);
export const BuildingIcon = createIcon(H.Building01Icon);
export const Calendar03Icon = createIcon(H.Calendar03Icon);
export const Call02Icon = createIcon(H.Call02Icon);
export const CheckCircleIcon = createIcon(H.CheckmarkCircle01Icon);
export const CheckIcon = createIcon(H.Tick01Icon);
export const ChevronDownIcon = createIcon(H.ChevronDown);
export const ChevronLeftIcon = createIcon(H.ChevronLeft);
export const ChevronRightIcon = createIcon(H.ChevronRight);
export const CirclePlusIcon = createIcon(H.AddCircleIcon);
export const CircleXIcon = createIcon(H.CancelCircleIcon);
export const AssignmentsIcon = createIcon(H.AssignmentsIcon);
export const Clock01Icon = createIcon(H.Clock01Icon);
export const CloudDownloadIcon = createIcon(H.ArchiveArrowDownIcon);
export const CloudUploadIcon = createIcon(H.ArchiveArrowUpIcon);
export const CommandIcon = createIcon(H.CommandIcon);
export const Configuration01Icon = createIcon(H.Configuration01Icon);
export const Configuration02Icon = createIcon(H.Configuration02Icon);
export const CopyIcon = createIcon(H.Copy01Icon);
export const ComputerVideoIcon = createIcon(H.ComputerVideoIcon);
export const DashboardCircleEditIcon = createIcon(H.DashboardCircleEditIcon);
export const DashboardSpeed01Icon = createIcon(H.DashboardSpeed01Icon);
export const DepartementIcon = createIcon(H.DepartementIcon);
export const DocumentValidationIcon = createIcon(H.DocumentValidationIcon);
export const DollarSignIcon = createIcon(H.DollarIcon);
export const DownloadIcon = createIcon(H.Download);
export const EditIcon = createIcon(H.Edit01Icon);
export const EyeIcon = createIcon(H.ViewIcon);
export const FileBarChartIcon = createIcon(H.ChartBarLineIcon);
export const FileInputIcon = createIcon(H.FileDown);
export const FileSearchIcon = createIcon(H.FileSearchIcon);
export const FileTextIcon = createIcon(H.Agreement01Icon);
export const FileTransferIcon = createIcon(H.ArrowDataTransferHorizontalIcon);
export const FingerAccessIcon = createIcon(H.FingerAccessIcon);
export const GitBranchIcon = createIcon(H.SharingIcon);
export const GridIcon = createIcon(H.GridIcon);
export const GripVerticalIcon = createIcon(H.DragDropIcon);
export const HandIcon = createIcon(H.FourFinger03Icon);
export const HelpCircleIcon = createIcon(H.QuizIcon);
export const InfoIcon = createIcon(H.InformationCircleIcon);
export const JobLinkIcon = createIcon(H.JobLinkIcon);
export const JobSearchIcon = createIcon(H.JobSearchIcon);
export const LayoutDashboardIcon = createIcon(H.GridViewIcon);
export const LayoutGridIcon = createIcon(H.LayoutGridIcon);
export const ListIcon = createIcon(H.LeftToRightListBulletIcon);
export const LogOutIcon = createIcon(H.Logout01Icon);
export const MailIcon = createIcon(H.MailIcon);
export const MentoringIcon = createIcon(H.MentoringIcon);
export const More01Icon = createIcon(H.More01Icon);
export const MoreHorizontalIcon = createIcon(H.MoreHorizontalIcon);
export const MoreVerticalIcon = createIcon(H.MoreVerticalIcon);
export const PaperclipIcon = createIcon(H.AttachmentIcon);
export const Parabola03Icon = createIcon(H.Parabola03Icon);
export const ChartUpIcon = createIcon(H.ChartUpIcon);
export const PencilEdit02Icon = createIcon(H.PencilEdit02Icon);
export const ReloadIcon = createIcon(H.ReloadIcon);
export const SearchIcon = createIcon(H.Search01Icon);
export const SettingsIcon = createIcon(H.Settings02Icon);
export const ShieldIcon = createIcon(H.Shield01Icon);
export const StarIcon = createIcon(H.StarIcon);
export const TaskDaily01Icon = createIcon(H.TaskDaily01Icon);
export const TeachingIcon = createIcon(H.TeachingIcon);
export const LaptopPerformanceIcon = createIcon(H.LaptopPerformanceIcon);
export const TelephoneIcon = createIcon(H.TelephoneIcon);
export const Trash2Icon = createIcon(H.Delete02Icon);
export const TrashIcon = createIcon(H.Delete02Icon);
export const TrendingUpIcon = createIcon(H.AnalyticsUpIcon);
export const UploadIcon = createIcon(H.Upload01Icon);
export const UserCircleIcon = createIcon(H.UserCircleIcon);
export const UserCogIcon = createIcon(H.AccountSetting01Icon);
export const UserIcon = createIcon(H.UserIcon);
export const UserMultipleIcon = createIcon(H.UserMultiple02Icon);
export const UserQuestion02Icon = createIcon(H.UserQuestion02Icon);
export const UsersIcon = createIcon(H.UserGroupIcon);
export const VideoCameraAiIcon = createIcon(H.VideoCameraAiIcon);
export const RecordIcon = createIcon(H.RecordIcon);
export const CameraMicrophoneIcon = createIcon(H.CameraMicrophone01Icon);
export const XIcon = createIcon(H.Cancel01Icon);
export const XSquareIcon = createIcon(H.CancelSquareIcon);
export const AiSearchIcon = createIcon(H.AiSearch02Icon);

// Global Icon component for dynamic usage
export const HugeIcon = ({ icon, ...props }: { icon: any } & IconProps) => (
  <HugeiconsIcon icon={icon} {...props} />
);

